import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';

const ProductCard = ({ product }) => {
  const { user } = useAuth();
  const image = product.images && product.images[0] ? product.images[0].path : 'https://images.pexels.com/photos/5710082/pexels-photo-5710082.jpeg?auto=compress&cs=tinysrgb&w=800';
  const title = product.productTitle || 'Product';
  
  // Format price - show "From Login to View Price" if user is not logged in
  const getPriceText = () => {
    if (!user) {
      return 'From Login to View Price';
    }
    
    if (!product.msrp) {
      return 'Price not available';
    }
    
    // Parse and format the price
    const price = parseFloat(product.msrp);
    if (isNaN(price)) {
      return 'From Login to View Price';
    }
    
    // Format with commas for thousands
    return `$${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };
  
  const priceText = getPriceText();
  
  // Handle both 'color' (singular) and 'colors' (plural) for backward compatibility
  // Also handle if colors is a string that needs to be split
  let colors = product.color || product.colors || [];
  if (typeof colors === 'string') {
    // If it's a comma-separated string, split it
    colors = colors.split(',').map(c => c.trim()).filter(c => c.length > 0);
  }
  if (!Array.isArray(colors)) {
    colors = [];
  }
  
  // Helper function to convert color names to hex codes
  const getColorHex = (colorName) => {
    const colorMap = {
      'black': '#000000',
      'white': '#FFFFFF',
      'red': '#DC2626',
      'blue': '#1E3A8A',
      'yellow': '#FCD34D',
      'green': '#10B981',
      'gray': '#6B7280',
      'grey': '#6B7280',
      'purple': '#8B5CF6',
      'brown': '#7F1D1D',
      'orange': '#F59E0B',
      'navy': '#1E3A8A',
      'lightgray': '#D4D4D4',
      'lightgrey': '#D4D4D4',
    };
    return colorMap[colorName?.toLowerCase()] || '#000000';
  };

  return (
    <Link to={`/product/${product._id}`} className="group">
      <div className="relative bg-gray-100 rounded-lg overflow-hidden mb-4">
        <img
          src={image}
          alt={title}
          className="w-full h-[400px] object-cover"
        />
        {product.soldOut && (
          <span className="absolute top-4 right-4 bg-white px-4 py-1.5 rounded-full text-sm">
            Sold out
          </span>
        )}
      </div>

      <h3 className="text-base mb-2 text-gray-900">{title}</h3>
      <p className="text-sm text-gray-600 mb-3">{priceText}</p>

      {colors.length > 0 && (
        <div className="flex gap-2 flex-wrap">
          {colors.slice(0, 8).map((color, index) => (
            <button
              key={index}
              className="w-6 h-6 rounded-full border-2 border-transparent hover:border-gray-400 transition-colors"
              style={{ backgroundColor: getColorHex(color) }}
              aria-label={`Color option ${index + 1}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            />
          ))}
        </div>
      )}
    </Link>
  );
};

export default ProductCard;
